import { useState } from 'react'
import PropTypes from 'prop-types'
import { Phone, LockKey } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import SuccessConfirmationModal from '../../../Popups/SuccessConfirmationModal'
import ModalContainer from '../../../ModalContainer/ModelContainer'
import { useSnackbar } from '../../../../helpers/hooks/useSnackbar'
import API from '../../../../api/api'

const CallSettingsUpselling = ({ onClose = () => {}, buildingId }) => {
  const { t } = useTranslation(['chat'])
  const { displaySnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)
  const [isConfirmationVisible, setIsConfirmationVisible] = useState(false)

  const sendUpsellingMessage = async () => {
    try {
      setIsLoading(true)
      await API.sendUpsellingMessage({ type: 'callingFeature' }, buildingId)
      setIsConfirmationVisible(true)
    } catch ({ message }) {
      displaySnackbar(message, true)
    } finally {
      setIsLoading(false)
    }
  }

  if (isConfirmationVisible) {
    return (
      <SuccessConfirmationModal
        header={t('chat:callSettingsUpselling.requestSuccessHeader')}
        description={t('chat:callSettingsUpselling.requestSuccessDescription')}
        handleClose={() => {
          setIsConfirmationVisible(false)
          onClose()
        }}
      />
    )
  }

  return (
    <ModalContainer
      additionalClass={'call-settings-upselling-window'}
      onClose={onClose}
      headerTitle={t('chat:callSettingsUpselling.title')}
      headerIcon={<Phone />}
    >
      <div className="call-settings-upselling-window-container">
        <span className="warning">
          <LockKey weight="fill" />
          {t('chat:callSettingsUpselling.featureLocked')}
        </span>
        <h3>{t('chat:callSettingsUpselling.upgradeTitle')}</h3>
        <p>{t('chat:callSettingsUpselling.description')}</p>
        <img src="/images/unlock-call-settings.png" />
      </div>
      <div className="actions-container">
        <button
          className="button button-primary"
          disabled={isLoading}
          onClick={sendUpsellingMessage}
          style={{ width: '100%' }}
        >
          {t('chat:callSettingsUpselling.talkToAccountManager')}
        </button>
      </div>
    </ModalContainer>
  )
}

CallSettingsUpselling.propTypes = {
  onClose: PropTypes.func,
  buildingId: PropTypes.number,
}

export default CallSettingsUpselling
